// src/supabase/client.js

import { createClient } from '@supabase/supabase-js'

// Get Supabase credentials from environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Check if we're using placeholder values
const isUsingPlaceholders = !supabaseUrl || 
                           !supabaseAnonKey || 
                           supabaseUrl.includes('your-project-id') ||
                           supabaseAnonKey.includes('your_anon_key')

// Create a mock client for when credentials are missing
const createMockClient = () => {
  const errorMessage = `
    Supabase configuration is missing!
    
    Please:
    1. Update your .env file with your Supabase credentials:
       REACT_APP_SUPABASE_URL=https://your-project-id.supabase.co
       REACT_APP_SUPABASE_ANON_KEY=your_anon_key_here
    
    See SUPABASE_SETUP.md for complete setup instructions.
  `;
  
  return {
    auth: {
      signInWithPassword: () => Promise.reject(new Error(errorMessage)),
      signUp: () => Promise.reject(new Error(errorMessage)),
      signOut: () => Promise.reject(new Error(errorMessage)),
      getSession: () => Promise.reject(new Error(errorMessage)),
      onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } })
    }
  };
};

// Create the appropriate client based on configuration
let supabaseClient;
let authClient;

if (isUsingPlaceholders) {
  console.error('❌ Missing Supabase credentials!');
  console.error('Please update your .env file with your Supabase project URL and anon key.');
  console.error('See SUPABASE_SETUP.md for detailed instructions.');
  
  supabaseClient = createMockClient();
  authClient = supabaseClient.auth;
} else {
  // Validate URL format
  try {
    new URL(supabaseUrl);
  } catch (error) {
    console.error('❌ Invalid Supabase URL format!');
    console.error('URL should be: https://your-project-id.supabase.co');
    throw new Error(`Invalid Supabase URL: ${supabaseUrl}`);
  }
  
  // Create the actual Supabase client
  supabaseClient = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      detectSessionInUrl: true,
      flowType: "pkce",
      persistSession: true,
      autoRefreshToken: true,
    },
  });
  authClient = supabaseClient.auth;
}

// Export the clients
export const supabase = supabaseClient;
export const auth = authClient;
